import { Action } from "redux"

export const REQUEST_CONTENT = "TUTORIAL_REQUEST_CONTENT"
export const RECEIVE_CONTENT = "TUTORIAL_RECEIVE_CONTENT"

export interface ReceiveContent extends Action {
    content: Tutorial.Content
}

export const requestContent = (): Action => ({ type: REQUEST_CONTENT })

export const receiveContent = (content: Tutorial.Content): ReceiveContent => ({
    type: RECEIVE_CONTENT,
    content,
})

export const mapDispatchToProps = {
    requestContent,
    receiveContent,
}

export type DispatchProps = typeof mapDispatchToProps
